// import { CLIENT_SECRET, PARTNER_ID } from '../constants/globalConstants'
import { getPartnerDetails } from '../utils/helper'
// import { getUserSecret } from './secrets'

// const user = window.location.toString().split('/')[3]
export const getConfigDetails = () => {
  // switch ('demo') {
  // switch ('preStage') {
  // switch ('staging') {
  // switch ('preprod') {
  switch ('live') {
    case 'demo': //staging2
      return {
        // baseURL: 'https://demo-api.parkengage.com/',
        // PARTNER_ID: PARTNER_ID,
        // clientSecret: CLIENT_SECRET,

        baseURL: 'https://demo-api.parkengage.com/',
        partnerUrl: 'https://demo-admin.parkengage.com',
        adminUrl: 'https://demo-admin.parkengage.com',
        checkInUrl: 'https://demo-checkin.parkengage.com',
        transientURL: 'https://demo-transient.parkengage.com',
        ticketURL: 'https://demo-getreceipt.parkengage.com',
        portalURL: 'https://demo-customerportal.parkengage.com/navigating',
        portalBASEURL: 'https://demo-customerportal.parkengage.com',
        FACILITY_ID: 1,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',

      }
    case 'preStage': //staging
      return {
        baseURL: 'https://pre-stage-api.parkengage.com/',
        checkInUrl: 'https://pre-stage-checkin.parkengage.com',
        adminUrl: 'https://pre-stage-admin.parkengage.com',
        transientURL: 'https://pre-stage-transient.parkengage.com',
        ticketURL: 'https://pre-stage-getreceipt.parkengage.com',
        partnerUrl: 'https://pre-stage-admin.parkengage.com',
        portalURL: 'https://pre-stage-customerportal.parkengage.com/navigating',
        portalBASEURL: 'https://pre-stage-customerportal.parkengage.com',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',

      }
    case 'staging': //staging
      return {


        baseURL: 'https://staging-api.parkengage.com/',
        adminUrl: 'https://staging-admin.parkengage.com',
        checkInUrl: 'https://staging-checkin.parkengage.com',
        transientURL: 'https://staging-transient.parkengage.com',
        ticketURL: 'https://staging-getreceipt.parkengage.com',
        portalURL: 'https://staging-customerportal.parkengage.com/navigating',
        partnerUrl: 'https://staging-admin.parkengage.com',
        portalBASEURL: 'https://staging-customerportal.parkengage.com',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
        // CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : 'lAn4gbbzQSdkspdWJo0phdrDB',
        encryptPublicKey: '',
        chiperKey: 'ij9/kXBIEwuXX2OxjIcLLPMp0q3mVLIMvCk9NWUrm2k=',
        recaptchaSiteKey: '6LexXFwtAAAAAO-1nrIyKRYhh_MGrrEOkVAIXyi_',

      }
    case 'preprod': //staging
      return {
        baseURL: 'https://preprodnew-api.parkengage.com/',
        adminUrl: 'https://preprodnew-admin.parkengage.com',
        checkInUrl: 'https://preprodnew-checkin.parkengage.com',
        transientURL: 'https://preprodnew-transient.parkengage.com',
        ticketURL: 'https://preprodnew-getreceipt.parkengage.com',
        partnerUrl: 'https://preprodnew-admin.parkengage.com',
        portalURL: 'https://preprodnew-customerportal.parkengage.com/navigating',
        portalBASEURL: 'https://preprodnew-customerportal.parkengage.com',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '3307',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'parking-payments3307',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
        encryptPublicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1P16CGGcUkP7kHtSwLab+aNQHhLnN85uS4wl9N8yHLEcZp0/83b79fW14eaxv9SsnRNKXMmo0Rxh8xKWnhbfwUI4FELawWGWnMkJjHsRbBG+Ob802uuy7kqEldaSidrwwD9od5U/KGCnD0fOak1coDxhO9LZrbb/dbXWYRbTtKNvJt9p9W6UriSko3iz8AvKsF5i7hNs8iiNw0qe4sjCazBzx9KueQ9nKxczDWqW8PKSyaByH49THy+IwozYiJrvF/O8f2IUuyhkLtXgIISxYF9nUda4I8VmyAzXH7ulzgqDIuU0KsrLNzhKu6ZV6e1BMNfVb2kZLRfZZSNRsFGtLwIDAQAB',
        chiperKey: '8GKGgzEO+8o5AwsDE7nfOZiEQAUHeMQ0A8MdXkhTF4U=',

        // Payment Scripts
        googlePayScript: 'https://wallet-cert.dcap.com/v1/client/googlepay',
        googlePayDTScript: null,
        googlePayHLScript: null,

        applePayScript: 'https://wallet-cert.dcap.com/v1/client/applepay',
        applePayDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/datatrans-2.0.0.js',
        applePayHLScript: 'https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js',

        payButtonScript: 'https://pay.google.com/gp/p/js/pay.js',
        payButtonDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/payment-button-2.0.0.js',
        payButtonHLScript: null,

        // Optional local/dev override URLs (if used in some deployments)
        eventLocalUrl: 'http://localhost:3001',
        adminLocalUrl: 'http://localhost:5173',
        gatewayHLIframe: 'https://api2.heartlandportico.com/SecureSubmit.v1/token/2.4.1/securesubmit.js',
        gatewayDCIframe: 'https://token-cert.dcap.com/v1/client/hosted',
        // reptcha v3 site key
        recaptchaSiteKey: '6LexXFwtAAAAAO-1nrIyKRYhh_MGrrEOkVAIXyi_',
      }
    case 'live': //live
      return {
        baseURL: 'https://api.parkengage.com/',
        adminUrl: 'https://partner.parkengage.com',
        checkInUrl: 'https://checkin.parkengage.com',
        transientURL: 'https://transient.parkengage.com',
        ticketURL: 'https://getreceipt.parkengage.com',
        portalURL: 'https://customerportal.parkengage.com/navigating',
        partnerUrl: 'https://partner.parkengage.com',
        portalBASEURL: 'https://customerportal.parkengage.com',
        FACILITY_ID: 32,
        FULL_SEASON: '80',
        HALF_SEASON: '81',
        SIX_PACK: '82',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '3307',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'parking-payments3307',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
        encryptPublicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1P16CGGcUkP7kHtSwLab+aNQHhLnN85uS4wl9N8yHLEcZp0/83b79fW14eaxv9SsnRNKXMmo0Rxh8xKWnhbfwUI4FELawWGWnMkJjHsRbBG+Ob802uuy7kqEldaSidrwwD9od5U/KGCnD0fOak1coDxhO9LZrbb/dbXWYRbTtKNvJt9p9W6UriSko3iz8AvKsF5i7hNs8iiNw0qe4sjCazBzx9KueQ9nKxczDWqW8PKSyaByH49THy+IwozYiJrvF/O8f2IUuyhkLtXgIISxYF9nUda4I8VmyAzXH7ulzgqDIuU0KsrLNzhKu6ZV6e1BMNfVb2kZLRfZZSNRsFGtLwIDAQAB',
        chiperKey: 'Xx8HxBc7Z1KO/iJQ/UHAFpPUtNw+ND+W9iIBQIyL05k=',
        recaptchaSiteKey: '6LcIeVwtAAAAALTZAaDbeRg4_wXI4X1sh-gnCXAf',

      }
  }
}
